import { sessionMatchesTracker } from "./tracker";

export const newColorMaster = ({ isInviteMatch } = {}) => {
  // new opponent
  if (!isInviteMatch) return Math.random() > 0.5 ? 'black' : 'white';
  // invited opponent
  const { lastMatchOutcome: lastRes, lastMatchColor: lastCol } = sessionMatchesTracker;
  if (lastRes === 'WON') return 'black';
  if (lastRes === 'LOST') return 'white';
  if (lastRes === 'DRAW') return (lastCol === 'white' ? 'black' : 'white');
  return Math.random() > 0.5 ? 'black' : 'white';
};
